export const cmsData = {
  Sitecore: {
    labels: {
      MyFav: 'Favorites',
      MyFavSubtitle:
        'Use our wide selection of new and used cars, trucks, and SUVs to find your dream ride today!',
      ShopInventoryCta: 'Shop Inventory',
      NoSavedCar_Title: 'Nothing to see here. 💔',
      NoSavedCar_SubTitle:
        'You don’t have any vehicles saved. Visit our shopping tab to add a vehicle to your favorites.',
      NoSavedCar_ShopNow: 'Shop Now',
      Instigator_Title: 'Is Something Missing?',
      Instigator_SubTitle:
        'This vehicle is gone. Visit our shopping tab to find another one you love.',
      Instigator_Button: 'View More Inventory',
      NoVehicleTitle: 'Not finding what you’re looking for?',
      carsforsale: '/cars-for-sale',
      callForPrice: 'Call for Price',
      pendingSale: 'Pending Sale',
      ReservedBody:
        'This vehicle is reserved by another user. It may be available again in the future.',
      ReservedHeader: 'Reserved',
      DealPendingBody:
        'You are in the process of purchasing this vehicle. If that doesn’t sound right, you can remove it from the Deal Pending page.',
      DealPendingHeader: 'Deal Pending Vehicle',
      OnePriceHeader: '1Price Pre-Owned Vehicles',
      OnePriceBody:
        'The low price you see is the price you pay, online and in person. No need for haggling and uncomfortable price negotiations.',
      SubnavItems: [
        { "name": "My Garage", "isActive": false, "redirectTo": "/my-account/my-vehicle?owned=true" },
        { "name": "Favorites", "isActive": true, "redirectTo": "/my-account/my-favorite" },
        { "name": "Notifications", "isActive": false, "redirectTo": "/my-account/notifications" },
        { "name": "Service Visits", "isActive": false, "redirectTo": "" },
        { "name": "Settings", "isActive": false, "redirectTo": "/my-account/my-profile" }
      ]
    },
    TealiumSettings: {
      TealiumAccount: 'autonation',
      TealiumProfile: 'sitecorean',
      TealiumENV: 'dev',
    },
    LeadInformation: {
      HomePhone: '',
      ZipCode: '33301',
      isDashboard: false,
      HasSubmittedRangeOffer: false,
    },
  },
};
